import { createFileRoute } from '@tanstack/react-router'
import { HelmetShow } from '@/features/helmets/pages/helmet-show'

export const Route = createFileRoute('/_authenticated/helmets/$helmetId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { helmetId } = Route.useParams()
  return <HelmetShow helmetId={helmetId} />
}
